import React, { useState, useEffect } from "react";
import UsageHistoryTable from "./components/UsageHistoryTable";
import View from "./modals/View";
import Filter from "./modals/Filter";
import Divider from "@material-ui/core/Divider";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { updateObject } from "../../../helpers/updateObject";
import { dateConvertMonth } from "../../../helpers/dateConvertItem";
import ExportModal from "./modals/ExportModal";


export default function UsageHistory() {
  const [modalShow, setModalShow] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [exportParcent, setExportParcent] = useState(0);
  const [showEdit, setShowEdit] = useState(false);
  const [showView, setShowView] = React.useState(false);
  const [showFilter, setShowFilter] = React.useState(false);
  function handleChange() {
    setShowFilter((key) => !key);
  }

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setShowView(open);
  };

  const [error, setError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [sortField, setSortField] = useState("id");
  const [orderBy, setOrderBy] = useState(false);
  const [rows, setRows] = useState([]);
  const [usageHistory, setUsageHistory] = useState({});
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [deleteUsageHistorysIds, setDeleteUsageHistorysIds] = useState([]);
  const [filter, setFilter] = useState(false);
  const [filterInputs, setFilterInputs] = useState({
    assetId: "",
    partnerId: "",
    employeeId: "",
    startDate: "",
    endDate: "",
    campaignName: "",
  });

  const [assets, setAssets] = useState([]);
  const [partners, setPartners] = useState([]);
  const [employees, setEmployees] = useState([]);

  const onUsageHistorys = (skip, take, sortField, orderBy) => {
    setIsLoaded(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}usageHistory?Skip=${skip}&Take=${take}&SortField=${sortField}&OrderBy=${orderBy}`,
        {
          headers: {
            "Accept-Language": 1,
          },
        }
      )
      .then(
        ({ data: { data, totalCount } }) => {
          setIsLoaded(false);
          setRows(data);
          setCount(totalCount);
          setError(false);
        }
      ).catch((error) => {
        setIsLoaded(false);
        setError(true);
        setRows([]);
        setCount(0);
      });
  };
  const onFilter = (skip, take, sortField, orderBy, filterInputs) => {
    setIsLoaded(true);
    const {
      assetId,
      campaignName,
      partnerId,
      startDate,
      endDate,
      employeeId,
    } = filterInputs;
    axios
      .get(
        `${process.env.REACT_APP_API_URL}usageHistory/filter?Skip=${skip}&Take=${take}&SortField=${sortField}&OrderBy=${orderBy}&AssetId=${assetId}&PartnerId=${partnerId}&EmployeeId=${employeeId}&CampaignName=${campaignName}&StartDate=${dateConvertMonth(startDate)}&EndDate=${dateConvertMonth(endDate)}`,
        {
          headers: {
            "Accept-Language": 1,
          },
        }
      )
      .then(
        ({ data: { data, totalCount } }) => {
          setIsLoaded(false);
          setRows(data);
          setCount(totalCount);
          setError(false);
        },
        (error) => {
          setIsLoaded(false);
          setError(true);
          setRows([]);
          setCount(0);
        }
      );
  };

  const onUsageHistoryChoose = (id) => {
    axios
      .get(`${process.env.REACT_APP_API_URL}usageHistory/${id}`)
      .then(({ data }) => {
        setUsageHistory(data);
      });
  };

  const onUpdateUsageHistoryStatus = (id, statusType) => {
    let status = !statusType;
    axios
      .put(
        `${process.env.REACT_APP_API_URL}usageHistory/updateStatus`,
        {
          id,
          status,
        },
        {
          headers: {
            "x-requestid": uuid(),
          },
        }
      )
      .then(() => {
        onUsageHistorys(skip, take, sortField, orderBy);
      });
  };

  const onDeleteUsageHistorys = () => {
    axios
      .delete(`${process.env.REACT_APP_API_URL}usageHistory`, {
        headers: {
          "x-requestid": uuid(),
        },
        data: {
          id: deleteUsageHistorysIds,
        },
      })
      .then((res) => {
        setDeleteUsageHistorysIds([]);
        onUsageHistorys(skip, take, sortField, orderBy);
      });
  };

  const filterInputsUpdate = (e) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [e.target.id]: e.target.value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
    setFilter(true);
  };

  const filterInputsUpdateSelect = (key, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [key]: value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
    setFilter(true);
  };

  const onAssets = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}asset`, {
        headers: {
          "Accept-Language": 1,
        },
      })
      .then(({ data: { data } }) => {
        setAssets(data);
      });
  };

  const onPartners = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}partner`, {
        headers: {
          "Accept-Language": 1,
        },
      })
      .then(({ data: { data } }) => {
        setPartners(data);
      });
  };

  const onEmployees = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}employee/forAdmin`, {
        headers: {
          "Accept-Language": 1,
        },
      })
      .then(({ data: { data } }) => {
        setEmployees(data);
      });
  };

  useEffect(() => {
    onAssets();
    onPartners();
    onEmployees();
  }, []);

  useEffect(() => {
    if (filter) {
      const timer = setTimeout(() => {
        onFilter(skip, take, sortField, orderBy, filterInputs);
      }, 500);

      return () => clearTimeout(timer);
    } else {
      onUsageHistorys(skip, take, sortField, orderBy);
    }
  }, [skip, take, sortField, orderBy, filter, filterInputs]);

  useEffect(() => {
    if (!showView || !showEdit) setUsageHistory({});
  }, [showView, showEdit]);

  const onusageHistoriesExport = () => {
    setExportLoading(true);

    // axios
    //   .get(`${process.env.REACT_APP_API_URL}usageHistory/export/admin`, {
    //     responseType: "blob",
    //   })
    //   .then((res) => {
    //     var url = window.URL.createObjectURL(new Blob([res.data]));
    //     var a = document.createElement("a");
    //     a.href = url;
    //     a.download = "usageHistory.xlsx";
    //     document.body.appendChild(a);
    //     a.click();
    //     a.remove();
    //   });
    axios
      .get(`${process.env.REACT_APP_API_URL}usageHistory/export/admin?startDate=${filterInputs.startDate}&endDate=${filterInputs.endDate}`, {
        responseType: "blob",

        onDownloadProgress: (progressEvent) => {
          setExportLoading(false);
          const size = progressEvent.total;
          const current = progressEvent.loaded;

          let percentCompleted = Math.floor((current / size) * 100);
          setExportParcent(percentCompleted);
        },
      })
      .then((res) => {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var a = document.createElement("a");
        a.href = url;
        a.download = "EmployeeList.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();

        setModalShow(false)
      });
  };

  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4  fixed-title">
        <h1 className="display-4 mb-0">Usage History</h1>
        <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Hide filter" : "Show filter"}
          className="ml-auto mb-0"
        />
      </div>
      <Divider className="w-100" />
      <UsageHistoryTable
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        setOpenEdit={setShowEdit}
        setOpenView={toggleDrawer(true)}
        isLoaded={isLoaded}
        error={error}
        rows={rows}
        onUsageHistoryChoose={onUsageHistoryChoose}
        updateSkip={setSkip}
        updateTake={setTake}
        count={count}
        onUpdateUsageHistoryStatus={onUpdateUsageHistoryStatus}
        setDeleteUsageHistorysID={setDeleteUsageHistorysIds}
        deleteUsageHistorysIds={deleteUsageHistorysIds}
        onDeleteUsageHistorys={onDeleteUsageHistorys}
        onusageHistoriesExport={onusageHistoriesExport}
        setModalShow={setModalShow}

      />
      <View
        usagehistory={usageHistory}
        open={showView}
        onClose={toggleDrawer(false)}
      />
      <Filter
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputsUpdateSelect={filterInputsUpdateSelect}
        filterInputs={filterInputs}
        assets={assets}
        partners={partners}
        employees={employees}
      />

      <ExportModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        onExport={onusageHistoriesExport}
        exportLoaded={exportLoading}
        exportParcent={exportParcent}
        assets={assets}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
      />
    </div>
  );
}
